export const ERROR_CODES = {
    NO_FOUND_ADR_CODE: 'ERR_NO_FOUND_ADR',
    NO_SAVED_ADR_CODE: 'ERR_NO_SAVED_ADR',
};
